<template>
  <div class="tsa-toastv2" :class="[fullScreen? 'fullScreen' : 'noFullScreen']" v-show="show">
        <div class="tsaToast-content ">
            <span class="icon tsa-icon-warn2" :class="type ? type : ''"></span>
            <p>{{ message }}</p>
            <a href="javascript:;" v-show="actionShow" @click="action1">查看</a>
        </div>
        <div class="tsa-toast-mask"> </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'TsaCustomizeToast',
    data () {
        return {
            fullScreen: false,
            show: false,
            message: '',
            type: 'info',
            actionShow: false
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.disabled = false
            }
        }
    },
    methods: {
        action1 () {
            if (this.disabled) return
            this.disabled = true
            this.show = false
            this.action && this.action()
        },
    }
};
</script>
<style lang="scss" scoped>
    .tsa-toastv2 {
        position: fixed;
        z-index: 10012;
        .tsaToast-content {
            max-width: 80vw;
            height: max-content;
            // background: #FFFFFF;
            background: #344156;
            box-shadow: 0px 2px 8px 0px rgba(7,12,20,0.12);
            border-radius: 3px;
            display: flex;
            align-items: center;
            padding: 6px 16px;
            .icon {
                font-size: 14px;
                margin-right: 8px;
                &.info {
                    color: #2468F2;
                }
                &.success {
                    color: #30BF13;
                }
                &.warn {
                    color: #FF9326;
                }
                &.error {
                    color: #F33E3E;
                }
            }
            p {
                font-size: 14px;
                // color: #151B26;
                color: #FFFFFF;
                line-height: 20px;
            }
            a {
                flex-shrink: 0;
                font-size: 14px;
                color: #44BEFF;
                line-height: 20px;
                margin-left: 6px;
            }
        }
        &.noFullScreen {
            top: 90px;
            left: 50%;
            transform: translateX(-50%);
            width: max-content;
        }
        &.fullScreen {
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: flex;
            justify-content: center;
            // align-items: center;
            .tsa-toast-mask {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: -1;
                background-color: transparent;
            }
        }
        
    }
</style>
